import React from "react";
import {Badge} from "react-bootstrap";

export function OrderProgress({currentStep}) {
    const steps = ["submitted", "paid", "shipping", "delivered"];
    const specialStatus = ["draft", "cancelled", "refunded"];

    const capitalizeString = str => str.charAt(0).toUpperCase() + str.slice(1)

    // Get the index of the current step
    const currentStepIndex = steps.indexOf(currentStep.toLowerCase());

    const isSpecialStatus = specialStatus.includes(currentStep.toLowerCase())

    return (
        <>
            {isSpecialStatus ? (
                <Badge bg="primary" className="fs-5">Order status: {capitalizeString(currentStep)}</Badge>
            ) : (
                <div className="container my-3">
                    <div className="d-flex justify-content-between mb-2">
                        {steps.map((step, index) => (
                            <div key={index}
                                 className={`text-center flex-fill border-5 border-bottom ${index <= currentStepIndex ? 'fw-bold text-info border-info' : 'text-muted border-light-subtle'}`}>
                                {step}
                            </div>
                        ))}
                    </div>
                </div>
            )
            }

            {/*<div className="d-flex justify-content-center justify-content-md-around px-2">*/}

            {/*    /!* If the status is special (not part of normal steps), show it *!/*/}
            {/*    {isSpecialStatus ? (*/}
            {/*        <Badge bg="primary" className="fs-5">Order status: {capitalizeString(currentStep)}</Badge>*/}
            {/*    ) : (*/}
            {/*        <>*/}
            {/*            /!* Step Circles *!/*/}
            {/*            <div className="d-flex align-items-center justify-content-between w-75 my-4">*/}
            {/*                {steps.map((step, index) => (*/}
            {/*                    <div*/}
            {/*                        key={index}*/}
            {/*                        className={`d-flex align-items-center position-relative ${*/}
            {/*                            index === steps.length - 1 ? "" : "flex-grow-1"*/}
            {/*                        }`}*/}
            {/*                    >*/}
            {/*                        {index < steps.length - 1 && (*/}
            {/*                            <div*/}
            {/*                                className={`border-top border-2 position-absolute top-50 start-0 ${*/}
            {/*                                    index <= currentStepIndex ? "border-primary" : "border-light-subtle"*/}
            {/*                                }`}*/}
            {/*                                style={{width: "100%", left: "-50%", zIndex: -1}}*/}
            {/*                            ></div>*/}
            {/*                        )}*/}

            {/*                        <div*/}
            {/*                            className={`d-flex flex-column justify-content-center align-items-center rounded-circle ${*/}
            {/*                                index <= currentStepIndex ? "bg-primary text-white" : "bg-light-subtle text-body-tertiary"*/}
            {/*                            }`}*/}
            {/*                            style={{width: "30px", height: "30px", zIndex: 1}}*/}
            {/*                        >*/}
            {/*                            {index < currentStepIndex ? (*/}
            {/*                                <i className="bi bi-check mt-4" style={{transform: "scale(1.5)"}}/>*/}
            {/*                            ) : (*/}
            {/*                                <div className="mt-4">{index + 1}</div>*/}
            {/*                            )}*/}

            {/*                            <div className={`${index <= currentStepIndex ? "fw-semibold text-primary" : "text-body-tertiary"}`}>*/}
            {/*                                <small>{capitalizeString(step)}</small>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                ))}*/}
            {/*            </div>*/}
            {/*        </>*/}
            {/*    )}*/}

            {/*</div>*/}
        </>
    );
}
